module.exports = __webpack_public_path__ + "static/media/projects_config.78163e5a.yaml";